import { notifications } from "@mantine/notifications";
import i18next from "i18next";

export function showErrorNotification(message: string, title?: string) {
  notifications.show({
    title: title ?? i18next.t("common.error"),
    message,
    color: "red",
    autoClose: 5000,
    role: "alert",
  });
}

export function showSuccessNotification(message: string) {
  notifications.show({
    title: i18next.t("common.success"),
    message,
    color: "green",
    autoClose: 3000,
    role: "status",
  });
}
